<template>
  <div class="personal-buy grid grid-cols-2 gap-[16px]">
    <div v-for="item in packages" :key="item.id">
      <div class="title">
        {{ item.title }}
      </div>
      <div
        :class="[
          'card rounded-[8px] bg-back-2 pl-[25px] py-[25px] mt-[10px] cursor-pointer',
          {
            active: item.id === picked?.id,
          },
        ]"
        @click.stop="handlePick(item)"
      >
        <div v-if="item.free_credit_coins > 0" class="coin-free">
          {{
            $t('jia-song-itemfreecreditcoins-yan-bi', [item.free_credit_coins])
          }}
        </div>
        <div class="price text-error-6 font-bold">
          <span class="price-prefix text-[16px]">
            {{ formatPrice(item.price).prefix }}
          </span>
          <span class="price-num text-[28px]">
            {{ formatPrice(item.price).value }}
          </span>
        </div>
        <div class="coin-count">
          <span class="icon-value text-primary text-[14px] mr-[4px]">
            {{
              $t('gong-itemtotalcreditcoins-yan-bi', [item.total_credit_coins])
            }}
            <br v-if="isGlobalVersion()" />
            {{
              $t(
                'yu-ji-sheng-chan-getavailabletimecountitemtotalcreditcoins-shi-pin',
                [getAvailableTimeCount(item.total_credit_coins)]
              )
            }}
            <a-tooltip placement="right">
              <template #title>
                {{
                  $t(
                    'gen-ju-quan-ping-tai-yong-hu-ping-jun-xiao-shuai-ji-suan-shi-ji-xiao-hao-yan-bi-shu-yi-ge-ren-zhi-zuo-xiao-shuai-wei-zhun'
                  )
                }}
              </template>
              <iconpark-icon class="tip-icon" name="info"></iconpark-icon>
            </a-tooltip>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ICreditCoinsPackage } from '~/api'
import { useTime } from '~/hooks/useTime'
import { formatPrice } from '~/utils/equity-helper'
import { isChinese } from '~/utils/area'

const { $t } = useNuxtApp()

defineProps<{
  packages: ICreditCoinsPackage[]
  picked?: ICreditCoinsPackage
}>()

const emits = defineEmits(['change'])
const { formatDuration } = useTime()

const getAvailableTimeCount = (totalCreditCoins: number) => {
  return formatDuration(
    totalCreditCoins * (isChinese() ? 0.2 : 0.3) * 1000,
    (d) => {
      const s = d.seconds()
      const m = d.minutes()
      const h = d.hours()
      let str = ''
      if (s > 0) {
        str = $t('dseconds-miao', [d.seconds()])
      }
      if (m > 0 || h > 0) {
        str = $t('dminutes-fen-zhong', [m + h * 60]) + str
      }
      return str
    }
  )
}

const handlePick = (v: ICreditCoinsPackage) => emits('change', v)
</script>

<style scoped lang="scss">
.card {
  position: relative;
  border: 2px solid transparent;
}
.active {
  &.active {
    border: 2px solid var(--purple-6);
    background-color: var(--purple-2);
    overflow: hidden;
  }
}
.coin-free {
  position: absolute;
  right: -2px;
  top: -2px;
  background: linear-gradient(110deg, #d53fff 0%, #ff386c 100%);
  border-radius: 0px 8px 0px 8px;
  color: #ffffff;
  font-size: 12px;
  padding: 2px 8px;
}
.title {
  font-weight: 500;
  font-size: 14px;
}
.tip-icon {
  transform: translateY(2px);
  color: var(--text-1);
}
</style>
